export const responseAthenaEncryption = {
  data: {
    attributes: {
      awsSecretKey: 'awsAthenaSecretKey'
    }
  }
};